import React from 'react';
import PropTypes from 'prop-types';
import classes from './RenderSectionParagraph.module.scss';

const RenderSectionParagraph = (props) => {
    const { data } = props;
    if (data?.length === 0) return null;

    const Paragraph = ({ paraObject }) => {
        const { para, is_bold, is_italic, is_underlined, } = paraObject || {};
        if (para == "") return null;
        const BoldClass = is_bold ? classes.Bold : '';
        const ItalicClass = is_italic ? classes.Italic : '';
        const UnderlineClass = is_underlined ? classes.Underline : '';
        return (
            <p className={`${classes.Paragraph} ${BoldClass} ${ItalicClass} ${UnderlineClass}`}>{para}</p>
        )
    }

    return (
        <div className={classes.RenderSectionParagraph}>
            {data?.map((paraData, index) => <Paragraph key={`${paraData?.para?.slice(0, 12)}-${index}`} paraObject={paraData} />)}
        </div>
    )
}

RenderSectionParagraph.propTypes = {}

export default RenderSectionParagraph;